<template>
  <BaseDataIterator :service="fetchData">
    <template #default="dataIteratorProps">
      <div key="grid_view" class="p-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <BlogPostCard v-for="item in dataIteratorProps.data" :key="item.id" :page="item" />
        </BaseGrid>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountPagesClient } from '@/api/clients';
import BlogPostCard from './BlogPostCard.vue';

export default {
  components: {
    BlogPostCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  methods: {
    fetchData(params) {
      return accountPagesClient.list(this.accountId, {
        ...params,
        filter: {
          webpage_type__is: 'blog_post',
          ...(this.since && this.until
            ? { created_between: [this.since, this.until].join(',') }
            : {}),
        },
        page_size: 20,
      });
    },
  },
};
</script>
